import React, { useMemo } from 'react';

import { LinearProgress } from '@material-ui/core';
import matchSorter from 'match-sorter';
import {
  useTable,
  useExpanded,
  useFilters,
  useGlobalFilter
} from 'react-table';

const fuzzyTextFilterFn = (rows, id, filterValue) =>
  matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
fuzzyTextFilterFn.autoRemove = (val) => !val;

function OperatingExpensesTable({
  columns: userColumns,
  data,
  className,
  loading
}) {
  const filterTypes = useMemo(
    () => ({
      fuzzyText: fuzzyTextFilterFn,
      text: (rows, id, filterValue) =>
        rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        })
    }),
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns: userColumns,
        data,
        getSubRows: (row) =>
          row.children && row.children.length ? row.children : row.products,
        filterTypes
      },
      useFilters,
      useGlobalFilter,
      useExpanded
    );

  return (
    <div className={`${className && className}`}>
      <table {...getTableProps()} border="0">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps([
                    {
                      className: column.className
                    }
                  ])}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {loading && (
            <tr>
              <th colSpan="17" className="m10 textAlignCenter">
                <LinearProgress id="loading" variant="query" />
              </th>
            </tr>
          )}

          {rows?.length ? (
            rows.map(
              (row, i) =>
                prepareRow(row) || (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td
                        {...cell.getCellProps([
                          { className: cell.column.className }
                        ])}
                      >
                        {cell.render('Cell')}
                      </td>
                    ))}
                  </tr>
                )
            )
          ) : (
            <tr>
              <th colSpan="13" className="m10 textAlignCenter">
                Não há nenhum gasto
              </th>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default OperatingExpensesTable;
